import { type FC } from "react";
import styled from "styled-components";

import { ActionsBar } from "@ds/components/actions-bar";

import { Button, ButtonType } from "../forms/buttons";
import { IconType } from "../icons";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DetailsCardEditActionsMenu: FC<{
  isEditing: boolean;
  isDirty: boolean;
  hasValidationErrors?: boolean;
  isEditHidden?: boolean;
  onEdit?: () => void;
  onCancel?: () => void;
  onReset: () => void;
  onSubmit: () => void;
}> = ({ isEditing, isDirty, hasValidationErrors = false, isEditHidden, onEdit, onCancel, onReset, onSubmit }) => (
  <Wrapper>
    <ActionsBar>
      {onEdit && !isDirty && !isEditing && !isEditHidden && (
        <Button
          label="Edit"
          ariaLabel="details edit button"
          buttonType={ButtonType.Text}
          icon={IconType.Update}
          onClick={onEdit}
        />
      )}

      {onCancel && isEditing && (
        <Button
          label="Cancel"
          ariaLabel="details cancel edit button"
          buttonType={ButtonType.Text}
          icon={IconType.Close}
          onClick={onCancel}
        />
      )}

      {isDirty && (
        <Button
          label="Reset"
          ariaLabel="details reset button"
          buttonType={ButtonType.Text}
          icon={IconType.Undo}
          onClick={onReset}
        />
      )}

      {isDirty && (
        <Button
          label="Save"
          ariaLabel="details save button"
          buttonType={ButtonType.Text}
          icon={IconType.Save}
          onClick={onSubmit}
          isDisabled={hasValidationErrors}
        />
      )}
    </ActionsBar>
  </Wrapper>
);
